/**
 * Main layout wrapper with sidebar navigation
 */
import { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { GuestRegistrationBanner } from '@/components/auth/GuestRegistrationBanner';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-canvas">
      <Sidebar />

      {/* Main content area with proper spacing */}
      <main
        className="
          transition-all duration-300
          lg:ml-64
          lg:pt-0
          pb-20 lg:pb-0
          min-h-screen
        "
        style={{ paddingTop: 'calc(40px + max(env(safe-area-inset-top, 0px), 28px))' }}
      >
        {/* Guest Registration CTA Banner */}
        <GuestRegistrationBanner />

        <div className="h-full overflow-y-auto">
          {children}
        </div>
      </main>
    </div>
  );
}
